import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faLock } from "@fortawesome/free-solid-svg-icons";
import '../styles/cardyears.css'; // تأكد أن المسار صحيح

// تم إزالة isMobileDevice prop
function CardYear({ levels, loggedIn, auth }) {
    
    // التحقق من وجود البيانات لتجنب الأخطاء
    if (!levels || typeof levels.id === 'undefined') {
        return null; 
    }

    // الصور الجديدة حسب الـ ID
    const imageUrl = levels.id === 3 ? 
                      "/images/3prep.webp" :
                      levels.id === 4 ? 
                       "/images/1sec.webp"
                      :
                      
                       levels.id === 5 ? 
                       "/images/2sec-mecha-3lmy.png"
                       :
                       levels.id === 6 ? 
                       "/images/2sec-adaby.webp"
                       :
                       levels.id === 7 ? 
                       "/images/3sec.webp"
                       :
                      "/images/dsd.jpg";

    const textFalaky = `في سنة ${levels.id === 3 ? "ثالثة إعدادي" : 
                         levels.id === 4 ? "أولى ثانوي" :
                         levels.id === 5 ? "ثانية ثانوي علمي " :
                         levels.id === 6 ? "ثانية ثانوي أدبي" :
                         levels.id === 7 ? "ثالثة ثانوي" : "هذه المرحلة"}`;
    
    const textFalakyAuth = `في سنة ${auth.level === 3 ? "ثالثة إعدادي" : 
                           auth.level === 4 ? "أولى ثانوي" :
                           auth.level === 5 ? "ثانية ثانوي علمي رياضة" :
                           auth.level === 6 ? "ثانية ثانوي علمي علوم" :
                           auth.level === 7 ? "ثانية ثانوي أدبي" :
                           auth.level === 7 ? "ثالثة ثانوي" : "هذه المرحلة"}`;
    // ----------------------------------------------------

    const isUserLevel = loggedIn && auth.level === levels.id;
    const canViewContent = loggedIn && isUserLevel;
    const canNotViewContent = loggedIn && !isUserLevel;

    return (
        <div className="year-card">
            <div className="card-background" style={{ backgroundImage: `url(${imageUrl})` }}></div>
            <div className="card-overlay"></div>
            <div className="card-content">
                {/* <div className="level-title">
                    <span className="subtitle">الصف</span>
                    <h2 className="main-title">{levels.title ? levels.title.split(' ')[1] : ''}</h2>
                    <span className="subtitle">الثانوي</span>
                </div> */}
                <div className="card-actions">
                    {canViewContent ? (
                        <Link to={`/mycourses`} className="action-button primary">
                            شاهد المحتوى بتاعك <FontAwesomeIcon icon={faArrowLeft} />
                        </Link>
                    ) : canNotViewContent ? (
                        <button className="action-button disabled" disabled>
                            <FontAwesomeIcon icon={faLock} />هذا ليس صفك الدراسي
                        </button>
                    ) : (
                        <Link to={`/courses/${levels.id}`} className="action-button primary">
                            لو أنت {textFalaky} دوس هنا <FontAwesomeIcon icon={faArrowLeft} />
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CardYear;